/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import {connect} from 'react-redux'
import { browserHistory } from 'react-router'
import {isPC, isLZWKAPP, judgeAPPVersion} from '../../utils'
import { toShareCardPage } from '../../utils/connectApp'
import config from '../../config'
import MainItemTitle from './MainItemTitle'
import MainItemList from './MainItemList'
import MainItemBlock from './MainItemBlock'
import SharecardBtn from '../../images/liveroomSetting/liveroom-setting-sharecard.png'
import VIPBtn from '../../images/liveroomSetting/liveroom-setting-vip.png'
import WXBtn from '../../images/liveroomSetting/liveroom-setting-wx.png'
import ZZBBtn from '../../images/liveroomSetting/liveroom-setting-zzb.png'
import couponImg from '../../images/liveroomSetting/liveroom-setting-coupon.png'

class MainSaleList extends React.Component {

    render() {
        const {liveroomSetting} = this.props;
        const sharecardBtn = {
            img: SharecardBtn,
            text: '邀请卡',
            method: () => {
                if (isLZWKAPP()) {
                    toShareCardPage('liveroom', liveroomSetting.liveroom_id)
                } else {
                    window.location.href = `/liveroom/${liveroomSetting.liveroom_id}/sharecard`
                }
            }
        };
        const vipBtn = {
            img: VIPBtn,
            text: 'VIP会员',
            method: () => {
                location.assign(`/liveroom/${liveroomSetting.liveroom_id}/edit/vip`)
            }
        };
        const zzbBtn = {
            img: ZZBBtn,
            text: '至尊宝',
            method: () => {
                if (isPC()){
                    window.location.href = '/pc/service/zhizunbao/'
                }else {
                    window.location.href = 'https://mp.weixin.qq.com/s/btucxZ36zGwzQ8-eP3K8Tw'
                }
            }
        };
        const wxBtn = {
            img: WXBtn,
            text: '公众号接入',
            method: () => {
                if (isPC()){
                    window.location.href = config.ADMIN_BASE_URL + '/service/'
                }else {
                    window.location.href = 'https://mp.weixin.qq.com/s/GDsZu3yw1F8HZ_IgBZAWZA'
                }
            }
        };
        const couponBtn = {
            img: couponImg,
            text: '优惠券',
            method: () => location.assign(`/liveroom/${liveroomSetting.liveroom_id}/coupon/list?scope=liveroom`)
        };
        return (
            <div className="mianpage-sale-list">
                <MainItemTitle content={'营销工具'}/>

                <MainItemList>
                    <MainItemBlock blockContent={sharecardBtn}/>
                    <MainItemBlock blockContent={vipBtn}/>
                    <MainItemBlock blockContent={zzbBtn} hasBanner={true} bannerText='涨粉' />
                    <MainItemBlock blockContent={wxBtn}/>
                </MainItemList>
                <MainItemList>
                    <MainItemBlock blockContent={couponBtn} />
                </MainItemList>
            </div>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(MainSaleList)



// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainSaleList.js